function get_main_view(conf) {
    return {
        template: conf.template,
        controller: !conf.service_method_name ? undefined : [
            '$scope', 'paywalls_api', 'chartFilters',
            function($scope, paywalls_api, chartFilters) {
                function refresh_aggregation(model) {
                    service_method(model).then(resp => $scope.aggr = resp);
                }
                const service_method = paywalls_api[conf.service_method_name];
                const model = chartFilters.get_chart_filters();
                if (!conf.is_missions_required || model.filters.missions) {
                    refresh_aggregation(model);
                }
                chartFilters.onChangeChartParams('refresh_aggregation', refresh_aggregation);
                $scope.aggr = null;
            },
        ],
    };
}

function get_paywalls_state_config(conf) {
    const res = {
        url: conf.url,
        reloadOnSearch: false,
        data: {
            priority: 803,
            title: conf.title,
            role: 'paywalls',
        },
        views: {
            '': get_main_view(conf),
        },
    };
    if (conf.is_missions_required) {
        res.views['main-filter@amt.ww2'] = require('ww2_analytics/segments/missions_form');
    }
    return res;
}

export {
    get_paywalls_state_config,
};
